export const getDatasetThumbnailUrl = (id: string, updatedAt: string) =>
	`${process.env.DATASET_ASSETS_CLOUDFRONT_URL}/datasets/${id}/thumbnail.png?${updatedAt}`;
